import React from "react"
import { Button, DialogTitle, DialogContent, DialogActions } from "@mui/material"
import Dialog from "@mui/material/Dialog"
import i18n from "@/i18n"
import type { ConfirmDialogState } from "./types"

const STYLES = {
  dialogMessage: "text-gray-700",
} as const

type RemoveSectionDialogProps = {
  confirmDialog: ConfirmDialogState
  setConfirmDialog: (state: ConfirmDialogState) => void
}

const RemoveSectionDialog: React.FC<RemoveSectionDialogProps> = ({ confirmDialog, setConfirmDialog }) => {
  const handleClose = () => setConfirmDialog({ ...confirmDialog, open: false })

  return (
    <Dialog
      open={confirmDialog.open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      data-testid="settings-venue-layout-confirm-dialog"
    >
      <DialogTitle>{confirmDialog.title}</DialogTitle>
      <DialogContent>
        <div className={STYLES.dialogMessage}>{confirmDialog.message}</div>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="inherit" data-testid="settings-venue-layout-confirm-dialog-btn-cancel">
          {i18n.t("app.settings.venues.venue_layout.cancel")}
        </Button>
        <Button
          onClick={confirmDialog.onConfirm}
          color="error"
          variant="contained"
          data-testid="settings-venue-layout-confirm-dialog-btn-confirm"
        >
          {i18n.t("app.settings.venues.venue_layout.confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default RemoveSectionDialog
